require('dotenv').config();

const env = process.env;

export const API_URL = env.REACT_APP_API_URL || '';

export const COOKIE_EXPIRE_MINUTES: number = parseInt(process.env.REACT_APP_COOKIE_EXPIRE_MINUTES || '100', 10);

export const JWT_SECRET = env.REACT_APP_JWT_SECRET || '';

export const NODE_ENV = env.NODE_ENV || 'unknown';

